export const dayxMark = `<span class="brand-symbol" aria-hidden="true"><i></i><i></i><i></i></span><span class="dayx-word">Day<span>X</span></span>`;
